<template>
  <div :class="classList">
    <label>{{ label }}</label>
    <div v-if="description" class="description">{{ description }}</div>
    <div
      class="form-check pl-4"
      v-for="(option, index) in optionList"
      :key="'option' + index"
    >
      <input
        class="form-check-input"
        type="radio"
        :value="option"
        :id="'radio-' + name + index"
        :checked="isCheck(option, index)"
        @change="handleOnChange(option, index)"
      />
      <label class="form-check-label ml-1" :for="'radio-' + name + index">
        {{ option }}
      </label>
    </div>
    <div
      v-if="
        hasOther && value != null && !optionListExcludeOther.includes(value)
      "
    >
      <input
        type="text"
        class="form-control"
        :value="getOtherValue"
        @input="handleOtherTextboxInput($event)"
      />
    </div>
    <p
      class="required-message"
      v-if="value == null && submitClicked && isRequired"
    >
      This field is required.
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a radio group, which includes radio buttons and its label
Any error of the radio group (for example: required field) is showed in this component */
export default {
  name: "RadioGroup",
  props: {
    /* Name of the radio component, it is used in id of each radio button,
    therefore it need to be different between RadioGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: [String, Boolean],
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for radio buttons (the label of each radio buttons)
    optionList: {
      type: Array,
      default: () => ["Yes", "No"]
    },
    hasOther: {
      type: Boolean,
      default: false
    },
    // TODO, inital selected option
    initialSelection: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // Option to use 'Yes', 'No' for boolean model instead of true, false (in case out of boolean_selector)
    isBooleanModel: {
      type: Boolean,
      default: true
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  created() {
    if (this.initialSelection && this.value == null) {
      this.$emit("input", this.initialSelection);
    }
  },
  // created() {
  //   if (this.isBooleanRadioGroup()) {
  //     this.$emit("input", true);
  //   } else {
  //     this.$emit("input", this.optionList[0]);
  //   }
  // },
  computed: {
    getOtherValue() {
      if (!this.optionListExcludeOther.includes(this.value)) {
        return this.value;
      }
    },
    optionListExcludeOther() {
      return this.optionList.slice(0, -1);
    }
  },
  methods: {
    isCheck(option, index) {
      if (this.isBooleanRadioGroup()) {
        if (this.value === true) {
          return option === "Yes";
        } else if (this.value === false) {
          return option === "No";
        }
        return false;
      } else {
        if (this.hasOther && this.value != null) {
          if (index === this.optionList.length - 1) {
            if (!this.optionListExcludeOther.includes(this.value)) {
              return true;
            }
          }
        }
        return option === this.value;
      }
    },
    handleOnChange(option, index) {
      if (this.isBooleanRadioGroup()) {
        this.$emit("input", option === "Yes");
      } else {
        if (this.hasOther && index === this.optionList.length - 1) {
          this.$emit("input", "");
        } else {
          this.$emit("input", option);
        }
      }
    },
    handleOtherTextboxInput(event) {
      this.$emit("input", event.target.value);
    },
    isBooleanRadioGroup() {
      if (!this.isBooleanModel) {
        return false;
      }
      return (
        this.optionList.length === 2 &&
        this.optionList[0] === "Yes" &&
        this.optionList[1] === "No"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/RadioGroup.vue